define(['jquery'], function($){

	"use strict";

	$.infinitePaginationManager = function(containerId, loadingMessage, nextPageMessage, lastPageMessage, replacementCallback) {
		this.containerId = containerId;
		this.loadingMessage = loadingMessage;
		this.nextPageMessage = nextPageMessage;
		this.lastPageMessage = lastPageMessage;
		this.replacementCallback = replacementCallback;
	};

	$.infinitePaginationManager.prototype = {
		enhanceNextLink: function(pagination, addRowsByAjax, triggerOnView, triggerOnViewRangeVal) {
			var triggerOnViewRange = triggerOnViewRangeVal || -80;
			var nextLink = pagination.find("a.btn");
			var $nextLink = $(nextLink);
			var me = this;

			$nextLink.click(function(e) {
				pagination.find(".autoloader").html('<li><span class="noBackground">'+me.loadingMessage+'</span></li>');
				$.get($nextLink.attr("href"), addRowsByAjax);
				e.preventDefault();
			});
			if(triggerOnView) {
				$nextLink.triggerOnView({verticalRange: triggerOnViewRange});
			}
		},

		enhancePagination: function(pagination, addRowsByAjax, triggerOnView, triggerOnViewRange) {
			var nextPage = pagination.find("a.next");
			if (nextPage.length > 0) {
				pagination.html('<li><a href="' + nextPage.attr("href") + '" class="btn btn-default">' + this.nextPageMessage + '</a></li>');
				this.enhanceNextLink(pagination, addRowsByAjax, triggerOnView, triggerOnViewRange);
			} else {
				pagination.html('<li><span class="btn disabled">' + this.lastPageMessage + '</span></li>');
			}
		},

		enhanceArticleListing: function() {
			var pagination = $(".pagination");
			var mgrRef = this;
			var containerId = this.containerId;
			var triggerOnView = true;


			var addRowsByAjax = function(htmlResult) {
				var $htmlResult = $(htmlResult);

				var rows = $htmlResult.find("#" + containerId + " .list-detail");
				var lastRow = $("#" + containerId + " .list-detail:last");
				lastRow.after(rows);

				var newPagination = $htmlResult.find(".pagination");
				pagination.html(newPagination);
				mgrRef.enhancePagination(pagination, addRowsByAjax, triggerOnView);

				if ($.isFunction(mgrRef.replacementCallback)) {
					mgrRef.replacementCallback();
				}
			};

			this.enhancePagination(pagination, addRowsByAjax, triggerOnView);
		}



	};

	$.infinitePagination = function(containerId, loadingMessage, nextPageMessage, lastPageMessage, replacementCallback) {
		return new $.infinitePaginationManager(containerId, loadingMessage, nextPageMessage, lastPageMessage, replacementCallback);
	}

});


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.pagination.js